exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desmos-btn{background-color:#4f515a;color:white;padding:10px;border-radius:10px;margin-top:20px;margin-bottom:10px;cursor:pointer;border:none}.desmos-btn:hover{background-color:#78bcb8}\n", ""]);

// exports
